import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {mapArrowDefinitions} from '../../../lib/arrowHelper';
import ArrowLayer from './ArrowLayer';
import withResizable from '../../../lib/withResizable';

function DynamicArrowLayer({sourceRef, destinationRef, options}) {
  const source = sourceRef?.current ? sourceRef.current.getBoundingClientRect() : null;
  const destination = destinationRef?.current ? destinationRef.current?.getBoundingClientRect() : null;

  const arrowDef = useMemo(() => [mapArrowDefinitions(source, destination, options)], [source, destination, options]);

  return <ArrowLayer arrowDefinitions={arrowDef} strokeWidth="3" />;
}

DynamicArrowLayer.propTypes = {
  sourceRef: PropTypes.object.isRequired,
  destinationRef: PropTypes.object.isRequired,
  options: PropTypes.object,
};

DynamicArrowLayer.defaultProps = {
  options: null,
};

export default withResizable(DynamicArrowLayer);
